export class ApiLocalStorage {
  private static readonly TIMEOUT = 5000;

  static set(key: string, data: any) {
    try {
      localStorage.setItem(key, JSON.stringify(data));

      return true;
    } catch {
      return false;
    }
  }

  static get(key: string) {
    try {
      const data = localStorage.getItem(key);

      if (!data) return null;

      return JSON.parse(data);
    } catch {
      return null;
    }
  }

  static remove(key: string) {
    try {
      localStorage.removeItem(key);

      return true;
    } catch {
      return false;
    }
  }
}
